import styled from 'styled-components';
import { Container } from 'react-bootstrap';

export const DefaultHeaderContainer = styled.div`
  position: relative;
  background: #083a81;
  color: #666;
  font-family: 'Gotham-Book', arial, sans-serif;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0.02em;
  @media (max-width: 767px) {
    display: none;
  }
  @media print {
    display: none;
  }
`;

export const InnerContainer = styled.div`
  width: 1200px;
  height: 45px;
  margin: auto;
  @media (max-width: 1199px) {
    width: 960px;
  }
  @media (max-width: 991px) {
    width: 728px;
    text-align: center;
  }
`;

export const TransparentButton = styled.button`
  font-family: Gotham-Medium, arial, sans-serif;
  font-size: 13px;
  line-height: 13px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #0397d6;
  background: transparent;
  border: 0;
  height: 45px;
  padding: 0;
  span {
    padding: 16px 20px 14px 20px;
  }
  .icon-margin-right {
    margin-right: 20px;
    margin-bottom: 5px;
  }
  &.active {
    background-color: #075095;
  }
`;

export const SearchContainer = styled(Container)`
  background: #fff;
  position: absolute;
  z-index: 9999999;
  box-shadow: 2px 2px 2px rgb(0 0 0 / 10%);
  padding: 0 !important;
`;

export const ImageStyle = styled.img`
  position: relative;
  top: -6px;
  left: 0;
  display: block;
  width: auto;
  height: 25px;
  right: 20px;
`;

export const BlueButton = styled.a`
  background: transparent;
  color: #0397d6;
  cursor: pointer;
  position: relative;
  display: block;
  height: 45px;
  padding: 15px 20px 14px 20px;
  font-family: 'Gotham-Medium', arial, sans-serif;
  font-size: 13px;
  line-height: 13px;
  letter-spacing: 1px;
  text-transform: uppercase;
  text-decoration: none;
  :hover {
    text-decoration: none;
    color: #0397d6;
  }
`;
